module.exports = __webpack_public_path__ + "img/Q8.53843289.png";